<div class="btn-group btn-block" dropdown>
	<button dropdownToggle type="button" 
	    class="btn btn-light form-control dropdown-toggle btn-block input-btn" 
      aria-controls="dropdown-autoclose1" [ngClass]="{ 'is-invalid': hasError}">
       <span class="pull-left">{{label}}</span><span class="caret"></span>
    </button>
    <ng-template [ngIf]="!keepOrder" [ngIfElse]="sameorder">
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right scrollable-menu"
            role="menu" aria-labelledby="button-autoclose1" >
          <!-- <li role="menuitem">
            <div class="dropdown-item" (click)="select('-1', $event)" [class.active]="isActive('-1')" (mouseenter)="bindActiveEnter($event)" (mouseleave)="bindActiveLeave($event)">{{placeHolder}}</div>
          </li> -->
          <ng-template [ngIf]="!sortRequired" [ngIfElse]="sortobjorder">
            <li role="menuitem" *ngFor="let option of options">
              <div class="dropdown-item" (click)="select(option, $event)" [class.active]="isActive(option)" (mouseenter)="bindActiveEnter($event)" (mouseleave)="bindActiveLeave($event)">{{option[labelKey]}}</div>
            </li>
          </ng-template>
          <ng-template #sortobjorder>
            <li role="menuitem" *ngFor="let option of options |keyvalue: sortorder">
              <div class="dropdown-item" [ngStyle]="{'opacity': option.value.totalCount ===0 && option.value.CompletedCount===0? '0.5' : '1', 'pointer-events':option.value.totalCount ===0 && option.value.CompletedCount===0 ?'none':'pointer' }" (click)="select(option.value, $event)" [class.active]="isActive(option.value)" (mouseenter)="bindActiveEnter($event)" (mouseleave)="bindActiveLeave($event)">
                <span class="text-left">{{option.value[labelKey]}}</span><span class="pull-right"><span class="circleCountGreen">{{option.value.CompletedCount}}</span><span class="circleCount" *ngIf="option.value.totalCount >= 0">{{option.value.totalCount}}</span></span>
              </div>
            </li>
          </ng-template>
      </ul>
    </ng-template>
    <ng-template #sameorder>
      	<ul *dropdownMenu class="dropdown-menu dropdown-menu-right scrollable-menu"
          role="menu" aria-labelledby="button-autoclose1">
          <!-- <li role="menuitem">
            <div class="dropdown-item" (click)="select('-1', $event)" [class.active]="isActive('-1')" (mouseenter)="bindActiveEnter($event)" (mouseleave)="bindActiveLeave($event)">{{placeHolder}}</div>
          </li> -->
          <ng-template [ngIf]="!sortRequired" [ngIfElse]="sortorder">
          	<li  *ngFor="let option of options | keyvalue : keepItemOrder" 
          	 role="menuitem">
          		<div class="dropdown-item" (click)="select(option, $event)" 
          		[class.active]="isActive(option)" (mouseenter)="bindActiveEnter($event)"
          		(mouseleave)="bindActiveLeave($event)">{{option.value}}</div>
          	</li>
           </ng-template>
           <ng-template #sortorder>
            <li  *ngFor="let option of options | keyvalue" 
             role="menuitem">
              <div class="dropdown-item" (click)="select(option, $event)" 
              [class.active]="isActive(option)" (mouseenter)="bindActiveEnter($event)"
              (mouseleave)="bindActiveLeave($event)">{{option.value}}</div>
            </li>
           </ng-template>
      </ul>
    </ng-template>
</div>